import React from 'react';
import { queryString } from '@qadra/frontend-common';
import { Card } from '@qadra/frontend-common/atoms';
import { push } from '@qadra/frontend-common/redux';
import { useLocation } from 'react-router-dom';
import { useConnect, useDispatch } from '@qadra/frontend-common/redux/hooks';
import { useTranslate } from '@federico.moretti/react-translate';
import {
  Heading,
  Button,
  Alert,
  FlexWrapper,
  useMediaQuery,
  SPACINGS,
  useTheme,
  Paragraph,
  ActionText,
} from '@qadra/frontend-common-ts';
import { monitoring } from '@qadra/frontend-common/tracking';
import { CONFIRM_EMAIL } from '../redux/actions';
import { paths } from '../utils';
import { profilingCardStyle } from './styles';
import { MobileButtonContainer, MobileContainer } from './mobileStyles';

function ConfirmEmail() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const theme = useTheme();

  const { success, error } = useConnect((s) => ({
    success: s.confirmEmail.success,
    error: s.confirmEmail.error,
  }));
  const { code } = queryString.parse(location.search);

  React.useEffect(() => {
    if (code) {
      dispatch({ type: CONFIRM_EMAIL._REQUEST, payload: { code } });
    } else {
      monitoring.captureMessage('No code in ConfirmEmail page');
      dispatch(push(paths.login));
    }
  }, [dispatch, code]);

  const isMobile = useMediaQuery(theme.mediaQueries.isMobile);

  if (success) {
    if (isMobile) {
      return (
        <MobileContainer>
          <Heading
            style={{ marginTop: SPACINGS[8], marginBottom: SPACINGS[20] }}
            align="center"
            type={3}
          >
            {t('sso.confirmEmail.title')}
          </Heading>
          <Paragraph style={{ textAlign: 'center' }}>
            {t('sso.confirmEmail.confirmationMessage')}
          </Paragraph>
          <MobileButtonContainer>
            <Button size="lg" type="link" to={paths.login}>
              {t('sso.confirmEmail.nextButton')}
            </Button>
          </MobileButtonContainer>
        </MobileContainer>
      );
    }

    return (
      <FlexWrapper direction="column">
        <Card style={profilingCardStyle(theme)}>
          <Heading align="center" type={2} style={{ marginBottom: SPACINGS[12] }}>
            {t('sso.confirmEmail.title')}
          </Heading>
          <Paragraph style={{ textAlign: 'center' }}>
            {t('sso.confirmEmail.confirmationMessage')}
          </Paragraph>
        <FlexWrapper justify='center' style={{width: '100%', marginTop: SPACINGS[30]}}>
            <Button type="link" to={paths.login} style={{width: '300px'}}>
                {t('sso.confirmEmail.nextButton')}
            </Button>
        </FlexWrapper>
        </Card>
      </FlexWrapper>
    );
  }

  if (error) {
    if (isMobile) {
      return (
        <MobileContainer>
          <Alert type="danger" style={{ marginTop: SPACINGS[8] }}>
            {error}
          </Alert>
          <Heading
            style={{ marginTop: SPACINGS[8], marginBottom: SPACINGS[20] }}
            align="center"
            type={3}
          >
            {t('sso.confirmEmail.errorTitle')}
          </Heading>
          <Paragraph style={{ textAlign: 'center' }}>
            {t('sso.confirmEmail.contactSupport')}{' '}
            <ActionText transform="lowercase" type="link-external" to="mailto:support@qadra.com">
              support@qadra.com
            </ActionText>
          </Paragraph>
        </MobileContainer>
      );
    }

    return (
      <>
        <Alert
          type="danger"
          style={{ marginBottom: SPACINGS[12], width: theme.dimensions.maxCardWidth }}
        >
          {error}
        </Alert>
        <FlexWrapper direction="column">
          <Card style={profilingCardStyle(theme)}>
            <Heading align="center" type={2} style={{ marginBottom: SPACINGS[12] }}>
              {t('sso.confirmEmail.errorTitle')}
            </Heading>
            <Paragraph style={{ textAlign: 'center' }}>
              {t('sso.confirmEmail.contactSupport')}{' '}
              <a href="mailto:support@qadra.com">support@qadra.com</a>.
            </Paragraph>
          </Card>
        </FlexWrapper>
      </>
    );
  }

  return null;
}

export default ConfirmEmail;
